// extracted by mini-css-extract-plugin
export default {"sideContainer":"Landing_sideContainer__ulolq","side":"Landing_side__M9BUB","log":"Landing_log__C0Jhf","btn":"Landing_btn__OfJJT"};